import React, { useEffect } from "react";
import styled from "styled-components";
import { drawingTool } from "@stores/vars";
import { atom, useAtom, useAtomValue } from "jotai";
import Drawing from "@/drawing";
import ColorPicker from "./elements/ColorPicker";
import { colorPickerState } from "../stores/vars";
const Wrap = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  //background-color: rgba(0, 0, 0, 0.8);
  //z-index: 0;
`;
const Tools = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 40px;
  right: 80px;
  width: 1046px;
  padding: 10px 30px;
  box-sizing: border-box;
  border-radius: 60px;
  background-color: #272b40;
`;

const ToolBtn = styled.button`
  display: block;
  width: 84px;
  height: 84px;
  flex: none;
  background-color: #fff;
  &.undo {
    // pointer-events: none;
    // opacity: 0.3;
    background: url(${require("@assets/img/undo.png")}) no-repeat;
  }
  &.redo {
    // pointer-events: none;
    // opacity: 0.3;
    background: url(${require("@assets/img/redo.png")}) no-repeat;
  }
  &.small {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    &:before {
      content: "";
      display: block;
      width: 27px;
      height: 27px;
      background-color: var(--cur-colorpicker);
      border-radius: 50%;
    }
    &.on {
      &:before {
        border: 5px solid #fff;
      }
    }
  }
  &.medium {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    &:before {
      content: "";
      display: block;
      width: 37px;
      height: 37px;
      background-color: var(--cur-colorpicker);
      border-radius: 50%;
    }
    &.on {
      &:before {
        border: 5px solid #fff;
      }
    }
  }
  &.large {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    &:before {
      content: "";
      display: block;
      width: 49px;
      height: 49px;
      background-color: var(--cur-colorpicker);
      border-radius: 50%;
    }
    &.on {
      &:before {
        border: 5px solid #fff;
      }
    }
  }
  &.pencil {
    background: url(${require("@assets/img/pen.png")}) no-repeat;
    &.on {
      background: url(${require("@assets/img/pen_act.png")}) no-repeat;
    }
  }
  &.highlighter {
    background: url(${require("@assets/img/magicpen.png")}) no-repeat;
    &.on {
      background: url(${require("@assets/img/magicpen_act.png")}) no-repeat;
    }
  }
  &.eraser {
    background: url(${require("@assets/img/eraser.png")}) no-repeat;
    &.on {
      background: url(${require("@assets/img/eraser_act.png")}) no-repeat;
    }
  }

  &.colorpick {
    width: 55px;
    height: 55px;
    margin-top: 10px;
    background-color: var(--cur-colorpicker);
    //border-radius: 50%;
    border-radius: 0% 100% 100% 100%;
    transform: rotate(45deg);
    box-sizing: border-box;
    transition: background-color 0.3s;

    //background: url(${require("@assets/img/colorpick.png")}) no-repeat 50% 50%;
  }
  &.reset {
    background: url(${require("@assets/img/reset.png")}) no-repeat 50% 50%;
  }
`;

const SideTool = styled.div`
  position: absolute;
  right: 20px;
  top: 420px;
  z-index: 7;
  padding: 40px 25px;
  background-color: rgba(39, 43, 64, 0.8);
  border-radius: 40px;
  display: flex;
  flex-direction: column;
`;

const SideToolIcon = styled.button`
  position: relative;
  width: 53px;
  height: 53px;
  display: inline-block;
  margin: 15px 0;
  border-radius: 10px;
  overflow: hidden;
  &.icon1 {
    background: url(${require("@assets/img/d_board_1.png")}) no-repeat;
    background-size: 100% 100%;
  }
  &.icon2 {
    background: url(${require("@assets/img/d_board_2.png")}) no-repeat;
    background-size: 100% 100%;
  }
  &.icon3 {
    background: url(${require("@assets/img/d_board_3.png")}) no-repeat;
    background-size: 100% 100%;
  }

  &.active {
    border: 6px solid #ffd35c;
    box-sizing: border-box;
    border-radius: 10px;
  }
`;

const Label = styled.div`
  font-size: 30px;
  color: #fff;
  margin-bottom: 20px;
`;

const DrawingBackground = styled.div`
  position: absolute;
  position: absolute;
  left: 62px;
  top: 167px;
  width: 1796px;
  height: 878px;

  pointer-events: none;
  &.ty1 {
    background: url(${require("@assets/img/board_img1.png")}) no-repeat;
    background-size: 1796px 878px;
  }
  &.ty2 {
    background: url(${require("@assets/img/board_img2.jpg")}) no-repeat;
    background-size: 1796px 878px;
  }
`;

const drawingState = atom({
  type: "pencil",
  line: "medium",
});

// #flipbook
// #bookCover
const DrawingToolContainer = ({ onChangeColor }) => {
  const drawPanel = useAtomValue(drawingTool);
  const [isColorPicker, setView] = useAtom(colorPickerState);
  const [dState, setDState] = useAtom(drawingState);

  const onClick = (type) => {
    switch (type) {
      case "undo":
        Drawing.undo();
        break;
      case "redo":
        Drawing.redo();
        break;
      case "small":
        setDState({
          ...dState,
          line: "small",
        });
        Drawing.changeLine("small");
        break;
      case "medium":
        setDState({
          ...dState,
          line: "medium",
        });
        Drawing.changeLine("medium");
        break;
      case "large":
        setDState({
          ...dState,
          line: "large",
        });
        Drawing.changeLine("large");
        break;
      case "pencil":
        setDState({
          ...dState,
          type: "pencil",
        });
        Drawing.changeType("pencil");
        break;
      case "highlighter":
        setDState({
          ...dState,
          type: "highlighter",
        });
        Drawing.changeType("highlighter");
        break;
      case "eraser":
        setDState({
          ...dState,
          type: "eraser",
        });
        Drawing.changeType("eraser");
        break;
      case "reset":
        Drawing.clear();
        break;
      case "colorpick":
        setView(!isColorPicker);
        break;
      default:
        break;
    }
  };

  const activeSideToolClass = (idx) => {
    const icons = document.querySelectorAll(".s-icon");
    icons.forEach((el, i) => {
      if (i === idx) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  };

  const onSelectBoardType = (type) => {
    const bookCover = document.querySelector("#bookCover");
    const flipBook = document.querySelector("#flipbook");
    const drawBoard = document.querySelector("#draw_board");

    if (type === "ty1") {
      if (
        !document.querySelector("#bookContainer").classList.contains("first")
      ) {
        bookCover.style.display = "";
      }

      flipBook.style.display = "block";
      drawBoard.style.display = "none";
      drawBoard.classList.remove("ty1");
      drawBoard.classList.remove("ty2");
      activeSideToolClass(0);
    } else if (type === "ty2") {
      bookCover.style.display = "";
      flipBook.style.display = "none";
      drawBoard.style.display = "block";
      drawBoard.classList.remove("ty2");
      drawBoard.classList.add("ty1");
      activeSideToolClass(1);
    } else if (type === "ty3") {
      bookCover.style.display = "";
      flipBook.style.display = "none";
      drawBoard.style.display = "block";
      drawBoard.classList.remove("ty1");
      drawBoard.classList.add("ty2");
      activeSideToolClass(2);
    }
  };

  useEffect(() => {
    const bookCover = document.querySelector("#bookCover");
    const flipBook = document.querySelector("#flipbook");
    const drawBoard = document.querySelector("#draw_board");
    const soundButton = document.querySelector(".book-sound-button");

    if (drawPanel.active === true) {
      if (soundButton) soundButton.style.display = "none";
      onSelectBoardType("ty1");
    } else {
      if (soundButton) soundButton.style.display = "block";
      if (
        !document.querySelector("#bookContainer").classList.contains("first")
      ) {
        if (bookCover) bookCover.style.display = "";
      }
      if (flipBook) flipBook.style.display = "block";
      if (drawBoard) drawBoard.style.display = "none";
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawPanel.active]);

  useEffect(() => {
    return () => {
      setView(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return drawPanel.active ? (
    <Wrap>
      <ColorPicker onChange={onChangeColor} />
      <DrawingBackground id="draw_board" className="ty1" />
      <Tools>
        <ToolBtn
          type="button"
          className="undo"
          onClick={() => onClick("undo")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className="redo"
          onClick={() => onClick("redo")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className={dState.line === "small" ? "small on" : "small"}
          onClick={() => onClick("small")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className={dState.line === "medium" ? "medium on" : "medium"}
          onClick={() => onClick("medium")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className={dState.line === "large" ? "large on" : "large"}
          onClick={() => onClick("large")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className={dState.type === "pencil" ? "pencil on" : "pencil"}
          onClick={() => onClick("pencil")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className={
            dState.type === "highlighter" ? "highlighter on" : "highlighter"
          }
          onClick={() => onClick("highlighter")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className={dState.type === "eraser" ? "eraser on" : "eraser"}
          onClick={() => onClick("eraser")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className="colorpick"
          onClick={() => onClick("colorpick")}
        ></ToolBtn>
        <ToolBtn
          type="button"
          className="reset"
          onClick={() => onClick("reset")}
        ></ToolBtn>
      </Tools>
      <SideTool>
        <Label>칠판</Label>
        <SideToolIcon
          type="button"
          className="s-icon icon1"
          onClick={() => onSelectBoardType("ty1")}
        />
        <SideToolIcon
          type="button"
          className="s-icon icon2"
          onClick={() => onSelectBoardType("ty2")}
        />
        <SideToolIcon
          type="button"
          className="s-icon icon3"
          onClick={() => onSelectBoardType("ty3")}
        />
      </SideTool>
    </Wrap>
  ) : null;
};
export default React.memo(DrawingToolContainer);
